import Vue from 'vue'
import Router from 'vue-router'
import store from '@/stores/index';

Vue.use(Router)

const UnAuthorized = () => import(/* webpackChunkName: "unauthorized" */'@/views/UnAuthorized')

const LoginOrRegister = () => import(/* webpackChunkName: "login" */'@/views/account/LoginOrRegister')
const Login = () => import(/* webpackChunkName: "login" */'@/views/account/Login')
const LoginProfessional = () => import(/* webpackChunkName: "login" */'@/views/account/LoginProfessional')
const LoginClient = () => import(/* webpackChunkName: "login" */'@/views/account/LoginClient')

const Register = () => import(/* webpackChunkName: "register" */'@/views/account/Register')
const RegisterProfessional = () => import(/* webpackChunkName: "register" */'@/views/account/RegisterProfessional')
const RegisterClient = () => import(/* webpackChunkName: register" */'@/views/account/RegisterClient')

const ForgotPassword = () => import(/* webpackChunkName: "account" */'@/views/account/ForgotPassword')
const ResetPassword = () => import(/* webpackChunkName: "account" */'@/views/account/ResetPassword')
const ConfirmEmail = () => import(/* webpackChunkName: "account" */'@/views/account/ConfirmEmail')

const ClientProfileIndex = () => import(/* webpackChunkName: "client-profile" */'@/views/client/profile/Index')
const ClientProfileOverview = () => import(/* webpackChunkName: "client-profile" */'@/views/client/profile/Overview')
const ClientProfilePayment = () => import(/* webpackChunkName: "client-profile" */'@/views/client/profile/Payment')
const ClientProfileReferral = () => import(/* webpackChunkName: "professional-profile" */'@/views/client/profile/Referral')
const ClientProfileManagers = () => import(/* webpackChunkName: "professional-profile" */'@/views/client/profile/Managers')
const ClientProfileCredits = () => import(/* webpackChunkName: "professional-profile" */'@/views/client/profile/Credits')

const ProfessionalProfileIndex = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/Index')
const ProfessionalProfileOverview = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/Overview')
const ProfessionalProfileRates = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/Rates')
const ProfessionalProfileEducations = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/Educations')
const ProfessionalProfileWorkArea = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/WorkArea')
const ProfessionalProfilePassManager = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/PassManager')
const ProfessionalProfilePayment = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/Payment')
const ProfessionalProfilePassRequest = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/PassRequest')
const ProfessionalProfileReferral = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/Referral')
const ProfessionalProfileCredits = () => import(/* webpackChunkName: "professional-profile" */'@/views/professional/profile/Credits')

const ProfileProfessionalWizard = () => import(/* webpackChunkName: "professional-profile-wizard" */'@/views/professional/profile/wizard/Index')
const ProfileClientWizard = () => import(/* webpackChunkName: "client-profile-wizard" */'@/views/client/profile/wizard/Index')

const ClientDashboard = () => import(/* webpackChunkName: "client" */'@/views/client/Dashboard')
const ClientAssignments = () => import(/* webpackChunkName: "client" */'@/views/client/Assignments')
const ClientPlanning = () => import(/* webpackChunkName: "client" */'@/views/client/Planning')
const ClientRequest = () => import(/* webpackChunkName: "client" */'@/views/client/Request')
const ClientProgress = () => import(/* webpackChunkName: "client" */'@/views/client/Progress')
const ClientActivities = () => import(/* webpackChunkName: "client" */'@/views/client/Activities')

const ProfessionalDashboard = () => import(/* webpackChunkName: "professional" */'@/views/professional/Dashboard')
const ProfessionalAssignments = () => import(/* webpackChunkName: "professional" */'@/views/professional/Assignments')
const ProfessionalProgress = () => import(/* webpackChunkName: "professional" */'@/views/professional/Progress')
const ProfessionalCalendar = () => import(/* webpackChunkName: "professional" */'@/views/professional/Calendar')
const ProfessionalWebshop = () => import(/* webpackChunkName: "professional" */'@/views/professional/Webshop')

const ProfessionalTools = () => import(/* webpackChunkName: "professional-tools" */'@/views/professional/tools/Index')
const ProfessionalActivities = () => import(/* webpackChunkName: "professional-tools" */'@/views/professional/tools/Activities')
const ProfessionalDebtors = () => import(/* webpackChunkName: "professional-tools" */'@/views/professional/tools/Debtors')
const ProfessionalCompanyDetails = () => import(/* webpackChunkName: "professional-tools" */'@/views/professional/tools/CompanyDetails')
const ProfessionalInvoice = () => import(/* webpackChunkName: "professional-tools" */'@/views/professional/tools/Invoice')
const ProfessionalInvoices = () => import(/* webpackChunkName: "professional-tools" */'@/views/professional/tools/Invoices')

const ProfessionalAssignment = () => import(/* webpackChunkName: "professional-assignment" */'@/views/professional/Assignment')
const ProfessionalAssignmentDescription = () => import(/* webpackChunkName: "professional-assignment" */'@/views/professional/assignment/Description')
const ProfessionalAssignmentChat = () => import(/* webpackChunkName: "professional-assignment" */'@/views/professional/assignment/Chat')
const ProfessionalAssignmentReport = () => import(/* webpackChunkName: "professional-assignment" */'@/views/professional/assignment/Report')
const ProfessionalAssignmentReview = () => import(/* webpackChunkName: "professional-assignment" */'@/views/professional/assignment/Review')
const ProfessionalAssignmentPayment = () => import(/* webpackChunkName: "professional-assignment" */'@/views/professional/assignment/Payment')

const ClientAssignment = () => import(/* webpackChunkName: "Client-assignment" */'@/views/client/Assignment')
const ClientAssignmentDescription = () => import(/* webpackChunkName: "Client-assignment" */'@/views/client/assignment/Description')
const ClientAssignmentChat = () => import(/* webpackChunkName: "Client-assignment" */'@/views/client/assignment/Chat')
const ClientAssignmentReport = () => import(/* webpackChunkName: "Client-assignment" */'@/views/client/assignment/Report')
const ClientAssignmentReview = () => import(/* webpackChunkName: "Client-assignment" */'@/views/client/assignment/Review')
const ClientAssignmentPayment = () => import(/* webpackChunkName: "Client-assignment" */'@/views/client/assignment/Payment')

const ifProfessional = (to, from, next) => {
  if(store.getters.type.toLowerCase() == "professional")
      return next();
  return next({ name: "UnAuthorized" });
}

const ifClient = (to, from, next) => {
  if(store.getters.type.toLowerCase() == "client")
      return next();
  return next({ name: "UnAuthorized" });
}

const isIE = () => {
  const ua = navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones*/
  const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

  return is_ie; 
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { 
        path: "*", 
        //redirect: "/security",
        beforeEnter(to, from, next) {
            if(!to.fullPath.endsWith(".html") || to.fullPath.endsWith("app.html")|| to.fullPath.endsWith("index.html"))
                return next({ name: 'Account' })
        }
    },
    {
        path: "/unauthorized", 
        name: 'UnAuthorized',
        component: UnAuthorized, 
        meta: {
            title: 'Geen Toegang',
            canonical: 'https://app.azurity.nl/unauthorized'
        },
    },
    { //client
        path: "/client", 
        name: 'Client',
        component: ClientDashboard,
        meta: {
            auth: true,
            title: 'Opdrachtgever',
            canonical: 'https://app.azurity.nl/client'
        },
        children: [
            { //profile-wizard
                path: "wizard", 
                name: 'ClientWizard',
                component: ProfileClientWizard, 
                meta: {
                    title: 'Profiel Wizard | Opdrachtgever',
                },
                beforeEnter: ifClient,
                children: []
            },
            {
                path: "assignment/:id", 
                name: 'ClientAssignment',
                component: ClientAssignment, 
                redirect: { name: 'ClientAssignmentDescription' },
                children: [
                    {
                        path: "description", 
                        name: 'ClientAssignmentDescription',
                        component: ClientAssignmentDescription, 
                        meta: {
                            title: 'Opdracht | Opdrachtgever',
                        },
                        children: [],
                    },
                    {
                        path: "chat", 
                        name: 'ClientAssignmentChat',
                        component: ClientAssignmentChat, 
                        meta: {
                            title: 'Opdracht | Berichten | Opdrachtgever',
                        },
                        children: [],
                    },
                    {
                        path: "report", 
                        name: 'ClientAssignmentReport',
                        component: ClientAssignmentReport, 
                        meta: {
                            title: 'Opdrachten | Rapportage | Opdrachtgever',
                        },
                        children: [],
                    },
                    {
                        path: "review", 
                        name: 'ClientAssignmentReview',
                        component: ClientAssignmentReview, 
                        meta: {
                            title: 'Opdrachten | Review | Opdrachtgever',
                        },
                        children: [],
                    },
                    {
                        path: "payment", 
                        name: 'ClientAssignmentPayment',
                        component: ClientAssignmentPayment, 
                        meta: {
                            title: 'Opdrachten | Betaling | Opdrachtgever',
                        },
                        children: [],
                    },
                ]
            },
            {
                path: "assignments", 
                name: 'ClientAssignments',
                component: ClientAssignments, 
                meta: {
                    title: 'Opdrachten | Opdrachtgever',
                },
                children: []
            },
            {
                path: "planning", 
                name: 'ClientPlanning',
                component: ClientPlanning, 
                meta: {
                    title: 'Planning | Opdrachtgever',
                },
                children: []
            },
            {
                path: "request", 
                name: 'ClientRequest',
                component: ClientRequest, 
                meta: {
                    title: 'Aanvraag | Opdrachtgever',
                },
                children: []
            },
            {
                path: "progress", 
                name: 'ClientProgress',
                component: ClientProgress, 
                meta: {
                    title: 'Voortgang | Opdrachtgever',
                },
                children: []
            },
            {
                path: "hiring", 
                name: 'ClientActivities',
                component: ClientActivities, 
                meta: {
                    title: 'Inhuur | Opdrachtgever',
                },
                children: []
            },
            { //profile
                path: "profile", 
                name: 'ClientProfile',
                component: ClientProfileIndex, 
                meta: {
                    title: 'Profiel | Beveiliger',
                },
                redirect: { name: 'ClientProfileOverview' },
                children: [
                    {
                        path: "overview", 
                        name: 'ClientProfileOverview',
                        component: ClientProfileOverview, 
                        meta: {
                            title: 'Profiel | Opdrachtgever',
                        },
                    },
                    {
                        path: "payment", 
                        name: 'ClientProfilePayment',
                        component: ClientProfilePayment, 
                        meta: {
                            title: 'Profiel | Opdrachtgever | Betalingen',
                        },
                    },
                    {
                        path: "managers", 
                        name: 'ClientProfileManagers',
                        component: ClientProfileManagers, 
                        meta: {
                            title: 'Profiel | Opdrachtgever | Leidinggevenden',
                        },
                    },
                    {
                        path: "credits", 
                        name: 'ClientProfileCredits',
                        component: ClientProfileCredits, 
                        meta: {
                            title: 'Profiel | Opdrachtgever | Credits',
                        },
                    },
                    {
                        path: "referral", 
                        name: 'ClientProfileReferral',
                        component: ClientProfileReferral, 
                        meta: {
                            title: 'Profiel | Opdrachtgever | Referral Programma',
                        },
                    }
                ]
            },
        ]
    },
    { //professional
        path: "/professional", 
        name: 'Professional',
        component: ProfessionalDashboard,
        meta: {
            auth: true,
            title: 'Opdrachtgever',
            canonical: 'https://app.azurity.nl/professional'
        },
        children: [
            {
                path: "assignment/:id", 
                name: 'ProfessionalAssignment',
                component: ProfessionalAssignment, 
                meta: {
                    title: 'Opdracht | Beveiliger',
                },
                redirect: { name: 'ProfessionalAssignmentDescription' },
                children: [
                    {
                        path: "description", 
                        name: 'ProfessionalAssignmentDescription',
                        component: ProfessionalAssignmentDescription, 
                        meta: {
                            title: 'Opdracht | Beveiliger',
                        },
                        children: [],
                    },
                    {
                        path: "chat", 
                        name: 'ProfessionalAssignmentChat',
                        component: ProfessionalAssignmentChat, 
                        meta: {
                            title: 'Opdracht | Berichten | Beveiliger',
                        },
                        children: [],
                    },
                    {
                        path: "report", 
                        name: 'ProfessionalAssignmentReport',
                        component: ProfessionalAssignmentReport, 
                        meta: {
                            title: 'Opdrachten | Rapportage | Beveiliger',
                        },
                        children: [],
                    },
                    {
                        path: "review", 
                        name: 'ProfessionalAssignmentReview',
                        component: ProfessionalAssignmentReview, 
                        meta: {
                            title: 'Opdrachten | Review | Beveiliger',
                        },
                        children: [],
                    },
                    {
                        path: "payment", 
                        name: 'ProfessionalAssignmentPayment',
                        component: ProfessionalAssignmentPayment, 
                        meta: {
                            title: 'Opdrachten | Betaling | Beveiliger',
                        },
                        children: [],
                    },
                ]
            },
            {
                path: "assignments", 
                name: 'ProfessionalAssignments',
                component: ProfessionalAssignments, 
                meta: {
                    title: 'Opdrachten | Beveiliger',
                },
                children: [],
            },
            {
                path: "calendar", 
                name: 'ProfessionalCalendar',
                component: ProfessionalCalendar, 
                meta: {
                    title: 'Kalender | Beveiliger',
                },
                children: [],
            },
            {
                path: "progress", 
                name: 'ProfessionalProgress',
                component: ProfessionalProgress, 
                meta: {
                    title: 'Voorgang | Beveiliger',
                },
                children: [],
            },
            {
                path: "webshop", 
                name: 'ProfessionalWebshop',
                component: ProfessionalWebshop, 
                meta: {
                    title: 'Webshop | Beveiliger',
                },
                children: [],
            },
            {
                path: "tools", 
                name: 'ProfessionalTools',
                component: ProfessionalTools, 
                meta: {
                    title: 'Tools | Beveiliger',
                },
                children: [
                    {
                        path: "company-details", 
                        name: 'ProfessionalCompanyDetails',
                        component: ProfessionalCompanyDetails, 
                        meta: {
                            title: 'Bedrijfslogo | Beveiliger',
                        },
                        children: [],
                    },
                    {
                        path: "debtors", 
                        name: 'ProfessionalDebtors',
                        component: ProfessionalDebtors, 
                        meta: {
                            title: 'Debiteuren | Beveiliger',
                        },
                        children: [],
                    },
                    {
                        path: "invoice/:id?", 
                        name: 'ProfessionalInvoice',
                        component: ProfessionalInvoice, 
                        meta: {
                            title: 'Factuur | Beveiliger',
                        },
                        children: [],
                    },
                    {
                        path: "invoices", 
                        name: 'ProfessionalInvoices',
                        component: ProfessionalInvoices, 
                        meta: {
                            title: 'Facturen | Beveiliger',
                        },
                        children: [],
                    },
                    {
                        path: "activities", 
                        name: 'ProfessionalActivities',
                        component: ProfessionalActivities, 
                        meta: {
                            title: 'Werkzaamheden Politie | Beveiliger',
                        },
                        children: [],
                    },
                ],
            },
            { //profile
                path: "profile", 
                name: 'ProfessionalProfile',
                component: ProfessionalProfileIndex, 
                meta: {
                    title: 'Profiel | Beveiliger',
                },
                redirect: { name: 'ProfessionalProfileOverview' },
                children: [
                    {
                        path: "overview", 
                        name: 'ProfessionalProfileOverview',
                        component: ProfessionalProfileOverview, 
                        meta: {
                            title: 'Profiel | Beveiliger',
                        },
                    },
                    {
                        path: "rates", 
                        name: 'ProfessionalProfileRates',
                        component: ProfessionalProfileRates, 
                        meta: {
                            title: 'Profiel | Beveiliger | Tarieven',
                        },
                    },
                    {
                        path: "educations", 
                        name: 'ProfessionalProfileEducations',
                        component: ProfessionalProfileEducations, 
                        meta: {
                            title: 'Profiel | Beveiliger | Opleidingen',
                        },
                    },
                    {
                        path: "workarea", 
                        name: 'ProfessionalProfileWorkArea',
                        component: ProfessionalProfileWorkArea, 
                        meta: {
                            title: 'Profiel | Beveiliger | Werkgebied',
                        },
                    },
                    {
                        path: "passmanager", 
                        name: 'ProfessionalProfilePassManager',
                        component: ProfessionalProfilePassManager, 
                        meta: {
                            title: 'Profiel | Beveiliger | Pas Manager',
                        },
                    },
                    {
                        path: "payment", 
                        name: 'ProfessionalProfilePayment',
                        component: ProfessionalProfilePayment, 
                        meta: {
                            title: 'Profiel | Beveiliger | Betalingen',
                        },
                    },
                    {
                        path: "pass-request", 
                        name: 'ProfessionalProfilePassRequest',
                        component: ProfessionalProfilePassRequest, 
                        meta: {
                            title: 'Profiel | Beveiliger | WPBR Pas',
                        },
                    },
                    {
                        path: "referral", 
                        name: 'ProfessionalProfileReferral',
                        component: ProfessionalProfileReferral, 
                        meta: {
                            title: 'Profiel | Beveiliger | Referral Programma',
                        },
                    },
                    {
                        path: "credits", 
                        name: 'ProfessionalProfileCredits',
                        component: ProfessionalProfileCredits, 
                        meta: {
                            title: 'Profiel | Beveiliger | Credits',
                        },
                    }
                ]
            },
            { //profile-wizard
                path: "profile/wizard", 
                name: 'ProfessionalWizard',
                component: ProfileProfessionalWizard, 
                meta: {
                    title: 'Profiel Wizard | Beveiliger',
                },
            },
        ]
    },
    { //account
        path: "/account", 
        name: 'Account',
        component: LoginOrRegister,
        meta: {
            title: 'Aanmelden of Inloggen',
            canonical: 'https://app.azurity.nl/account/'
        },
        children:
        [
            {
                path: "forgotpassword", 
                name: 'ForgotPassword',
                component: ForgotPassword, 
                meta: {
                    title: 'Wachtwoord Vergeten?',
                    canonical: 'https://app.azurity.nl/account/forgotpassword'
                },
            },
            {
                path: "resetpassword", 
                name: 'ResetPassword',
                component: ResetPassword, 
                meta: {
                    title: 'Wachtwoord Reset',
                    canonical: 'https://app.azurity.nl/account/resetpassword'
                }
            },
            {
                path: "confirmemail/:userid", 
                name: 'ConfirmEmail',
                component: ConfirmEmail, 
                meta: {
                    title: 'Email bevestigen',
                    canonical: 'https://app.azurity.nl/account/confirmemail'
                }
            },
            {
                path: "login", 
                name: 'Login',
                component: Login, 
                meta: {
                    title: 'Inloggen',
                    canonical: 'https://app.azurity.nl/account/login'
                },
                children: 
                [
                    {
                        path: "professional", 
                        name: 'LoginProfessional',
                        component: LoginProfessional, 
                        meta: {
                            title: 'Inloggen Beveiliger',
                            canonical: 'https://app.azurity.nl/account/login/professional'
                        },
                    },
                    {
                        path: "client", 
                        name: 'LoginClient',
                        component: LoginClient, 
                        meta: {
                            title: 'Inloggen Opdrachtgever',
                            canonical: 'https://app.azurity.nl/account/login/client'
                        },
                    }
                ]
            },
            {
                path: "register", 
                name: 'Register',
                component: Register, 
                meta: {
                    title: 'Aanmelden',
                    canonical: 'https://app.azurity.nl/account/register'
                },
                children: 
                [
                    {
                        path: "professional/:type?", 
                        name: 'RegisterProfessional',
                        component: RegisterProfessional, 
                        meta: {
                            title: 'Aanmelden Beveiliger',
                            canonical: 'https://app.azurity.nl/account/register/professional'
                        },
                    },
                    {
                        path: "client", 
                        name: 'RegisterClient',
                        component: RegisterClient, 
                        meta: {
                            title: 'Aanmelden Opdrachtgever',
                            canonical: 'https://app.azurity.nl/account/register/client'
                        },
                    }
                ]
            }
        ]
    }
  ]
})


router.beforeEach((to, from, next) => {
  //document.title = "Azurity | " + to.meta.title;
  if(!!Object.keys(from.query).length && !Object.keys(to.query).length)
  {
      next({name: to.name, query: from.query});
  }
  
  if(to.matched.some((c) => { return c.meta.auth }))
  {
      if(store.getters.isAuthenticated) {
          if(!store.getters.user.isCompleted)
          {
              if(to.name.toLowerCase() != store.getters.type.toLowerCase() + 'wizard')
              {
                  return next({ name: store.getters.type + "Wizard" });
              }
          }
          return next();
      } else 
      {
          return store.dispatch('AUTH_LOGOUT').then(() => {
              return next({ name: "Login" });
          });
      }
  } else if(store.getters.isAuthenticated && to.name != 'ConfirmEmail')
  {
      if(!to.matched.some((c) => { return c.meta.auth }))
      {
          return next({ name: store.getters.type });
      }
  }
  return next();
});

router.afterEach((to, from) => {
  setTimeout(() => {
      if(isIE())
      {
          window.scroll(0, 0);
      } else {
          window.scroll({
              top: 0, 
              left: 0, 
              behavior: 'smooth'
          })
      }
  },1);
  store.commit("COLLAPSE_MENU", false);
})

export default router;